<template>
  <ion-page>
    <master-layout pageTitle="اسکن بارکد سفارش">
      <ion-card-content>
        <div style="display: none" id="loadingMessage">🎥 </div>
        <canvas id="canvas" width="100%" hidden></canvas>
        <div class="camera-lens"></div>
      </ion-card-content>
    </master-layout>
  </ion-page>
</template>


<script>

// import MainPageItem from '/src/components/MainPageItem'
// import Money from '/src/components/Money'
import {
  IonCardContent, IonPage
} from "@ionic/vue";
import {mapActions} from "vuex";
import jsQR from '@/shared/jsQR'
import {openWebpage, showSystemNoti} from '@/shared/helper'


export default {
  components: {
    IonCardContent, IonPage
  },
  mounted()
  {
    this.video = document.createElement("video");
    this.canvasElement = document.getElementById("canvas");
    this.canvas = this.canvasElement.getContext("2d");
    this.loadingMessage = document.getElementById("loadingMessage");
    this.outputMessage = document.getElementById("outputMessage");
    this.outputData = document.getElementById("outputData");
    this.open_camera();
  },
  data()
  {
    return {
      currentStream: false,
      video: false,
      canvasElement: false,
      canvas: false,
      loadingMessage: false,
      outputMessage: false,
      outputData: false,
    }
  }, async created()
  {

  },
  methods: {
    ...mapActions("app", {
      checkScanOrderQrCode: 'checkScanOrderQrCode',
    }),
    async tick()
    {
      this.loadingMessage.innerText = "⌛ Loading video..."
      if (this.video.readyState === this.video.HAVE_ENOUGH_DATA)
      {
        this.loadingMessage.hidden = true;
        this.canvasElement.hidden = false;

        this.canvasElement.height = this.video.videoHeight;
        this.canvasElement.width = this.video.videoWidth;
        this.canvas.drawImage(this.video, 0, 0, this.canvasElement.width, this.canvasElement.height);
        var imageData = this.canvas.getImageData(0, 0, this.canvasElement.width, this.canvasElement.height);
        var code = jsQR(imageData.data, imageData.width, imageData.height, {
          inversionAttempts: "dontInvert",
        });
        if (code)
        {
          this.close_camera();
          // $('#camera_modal').modal('hide');
          const data = code.data;
          console.log(data)
          const check = await this.checkScanOrderQrCode(data);
          if (check && check.ok)
          {
            openWebpage(check.url);
          }
          else if (check)
            return showSystemNoti('danger',check.error);
          else
            return showSystemNoti('danger','خطای سرور');
        }
        else
        {
          //
        }
      }
      requestAnimationFrame(this.tick);
    },
    open_camera()
    {
      // $('#camera_modal').modal('show');
      // $('#canvas').show();
      navigator.mediaDevices.getUserMedia({video: {facingMode: "environment"}}).then((stream)=>
      {
        this.currentStream = stream;
        this.video.srcObject = stream;
        this.video.setAttribute("playsinline", true); // required to tell iOS safari we don't want fullscreen
        this.video.play();
        requestAnimationFrame(this.tick);
      });
    },
    close_camera()
    {
      try
      {
        this.currentStream.getTracks().forEach(function (track)
        {
          if (track.readyState === 'live')
          {
            track.stop();
          }
        });
      } catch (e)
      {
        //
      }
      // window.$('#canvas').hide();
    }
  },
  watch:{
    "$route.path":{
      handler(url)
      {
        if (url.indexOf('Auto/BarcodeScan')<0)
          this.close_camera();
        else
        {
          // window.$('#canvas').show();
          setTimeout(()=>{
            this.open_camera();
          },150)
        }
      }
    }
  }
};
</script>

<style scoped>
#canvas {
  width: 100%;
}
</style>